import React from 'react';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps
} from './useFormFieldProps';
import HBButtonGroup, {
    Props as HBButtonGroupProps
} from '../HBButtonGroup/HBButtonGroup';
import HBButtonGroupField, {
    HBButtonGroupFieldProps
} from '../HBButtonGroupField/HBButtonGroupField';

const HBFormButtonGroupField = (
    props: FormFieldProps<HBButtonGroupFieldProps>
) => {
    const { value, ...fieldProps } = useFormFieldProps(props);

    return <HBButtonGroupField {...fieldProps} selectedButton={value} />;
};

export const HBFormButtonGroup = (
    props: FormFieldProps<HBButtonGroupProps>
) => {
    const { value, testIdName, ...inputProps } = useFormInputProps(props);

    return (
        <HBButtonGroup
            {...inputProps}
            testIdName={testIdName}
            selectedButton={value}
        />
    );
};

export default HBFormButtonGroupField;
